import React from 'react';
import { Link } from 'react-router-dom';

function PatientSupport() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .support-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          International Patient Support in Delhi NCR: Premium Private Hospital Care Ecosystems
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Traveling overseas for major clinical treatments—such as complex cardiothoracic surgeries, advanced robotic joint modifications, or specialized oncology regimens—extends far beyond clinical competence. For global travelers, the quality of day-to-day administrative and logistical assistance heavily dictates post-operative healing outcomes. 
          The capital region has established itself as an elite destination by embedding comprehensive **international patient support systems** directly into its premier private healthcare landscape.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By leveraging public data frameworks on independent informational networks like <strong>Medical Trip World</strong>, international families can research available support structures, map out ground transport routes, and organize their travel itinerary protocols safely.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Access Free Patient Support Checklists & Toolkits →
        </Link>
      </div>

      {/* SECTION 1: THE REVENUE OF PRIVATE HOSPITAL CONCIERGE WORKFLOWS */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Pillars of Private International Patient Care Desks
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Unlike public municipal systems, multi-specialty private hospital groups in New Delhi, Gurgaon, and Noida manage dedicated corporate concierge lounges. These environments are engineered exclusively to handle the custom administrative and cultural needs of cross-border patients from the moment they land:
        </p>
        <ul style={{ paddingLeft: '20px', color: '#444', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Multilingual Interpretation Staff:</strong> Premium private centers employ native-speaking medical translators fluent in English, Arabic, French, Russian, Persian, and Swahili to protect patients against communication errors during sensitive clinical evaluations.
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Sovereign Registration Navigation (FRRO):</strong> National laws mandate that foreign visitors tracking medical treatments complete regulatory registration forms within strict timelines. Private support wings process these mandatory local paperwork sequences directly to minimize stress.
          </li>
          <li style={{ marginBottom: '0' }}>
            <strong>Customized Dietary & Cultural Planning:</strong> To maximize inpatient comfort, private wings offer personalized multi-cuisine meal plans, prayer room facilities, and international television networks to mirror familiar living standards.
          </li>
        </ul>
      </section>

      {/* SECTION 2: ADMINISTRATIVE METRICS CHECKLIST */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Logistical Coordination Checklist for Traveling Families
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          When comparing private medical infrastructures across Delhi NCR, international patients are advised to verify that their prospective care desk coordinates these essential data tracks:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Private Support Services Tracking Matrix:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>Dedicated Airport Transit Channels:</strong> Confirm if the private hospital desk supplies pre-arranged transport options, such as climate-controlled vehicles or non-emergency specialized ambulance shuttles directly from the international arrivals terminal.</li>
            <li style={{ marginBottom: '8px' }}><strong>Digital Triage & Record Preparation:</strong> Ensure the facility provides encrypted digital avenues to analyze your foreign laboratory files and pre-plan diagnostic checkups before you fly out.</li>
            <li style={{ marginBottom: '8px' }}><strong>Transparent Invoicing & Multi-Currency Systems:</strong> Top-tier private care desks provide comprehensive financial breakdowns accepting global wire transfers, corporate insurance lines, or secure digital credit networks to prevent surprise out-of-pocket costs.</li>
            <li style={{ marginBottom: '0' }}><strong>Local Telecommunication Provisioning:</strong> Most private guest wings assist family members in acquiring functional local SIM cards, mobile connectivity tools, and currency exchange certifications immediately upon arrival.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: SAFETY & VERIFICATION RESPONSIBILITY - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Verifying Support Services Independently
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates purely as an open informational venue and independent directory reference, we strongly advocate that patients verify administrative services directly with their selected facility before finalizing an itinerary:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Active Accreditation Registries</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Verify via official JCI or national NABH data logs that your chosen private hospital maintains active international quality benchmarks governing nursing ratios and clinical care hygiene.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Outpatient Commute Proximity</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Ensure that your post-discharge accommodation or serviced apartment complex rests within a comfortable 15 to 20-minute radius of the primary private medical treatment wing.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Patient Support Frameworks
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are international patient support services billed as an extra hospital cost?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. In the majority of premium corporate multi-specialty private networks across New Delhi and Gurgaon, basic support configurations—such as language interpretation, local FRRO document routing, and airport pickup arrangements—are completely built into the standard procedural package estimations.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can a patient's medical attendant stay inside the hospital room during treatment?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes. Leading private medical institutions design their international suites to include dedicated companion bedding areas, allowing family members holding a valid national Medical Attendant Visa to reside with the patient during standard inpatient stays.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World operate local transport vehicles or patient guest houses?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not provide logistics assets, run hospital desks, or maintain formal corporate partnerships or Memorandums of Understanding (MOUs) with any hospital brand or hotel chain. All clinical evaluations, pricing contracts, and service agreements occur directly and solely between the traveler and their self-selected private medical professional.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="support-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="support-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default PatientSupport;